import { atom, type createStore } from 'jotai/vanilla';

interface SeoExperimentState {
	metaTitle: string | null;
	metaDescription: string | null;
	headingTagOne: string | null;
}

/** @internal */
export const initialState: SeoExperimentState = {
	metaTitle: null,
	metaDescription: null,
	headingTagOne: null,
};

export const metaTitleAtom = atom(initialState.metaTitle);
export const metaDescriptionAtom = atom(initialState.metaDescription);
export const headingTagOneAtom = atom(initialState.headingTagOne);

export const getSeoExperimentDataToHydrate = (
	store: ReturnType<typeof createStore>,
) => {
	return {
		metaTitle: store.get(metaTitleAtom),
		metaDescription: store.get(metaDescriptionAtom),
		headingTagOne: store.get(headingTagOneAtom),
	};
};

export const getSeoExperimentInitialValues = (
	values: ReturnType<typeof getSeoExperimentDataToHydrate>,
) => {
	const { metaTitle, metaDescription, headingTagOne } = values || {};
	return [
		[metaTitleAtom, metaTitle || initialState.metaTitle],
		[metaDescriptionAtom, metaDescription || initialState.metaDescription],
		[headingTagOneAtom, headingTagOne || initialState.headingTagOne],
	];
};
